const LocaleData = {
  'courses.courseFilter.search': 'Suche',

  'associations.titles.cantonal': 'Kantonalvereinigung',
  'associations.titles.sectional': 'Stufenvereinigung',
  'associations.titles.president': 'Präsidium',
  'associations.titles.email': 'E-Mail',
}

export default LocaleData
